import { Component, computed, OnDestroy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { AssetBuilderService, RoleService } from '@rvi/asset-modules';
import { map } from 'rxjs';

@Component({
    selector: 'app-asset-type-page',
    templateUrl: './asset-type-page.component.html',
    styleUrl: './asset-type-page.component.scss',
    standalone: false,
})
export class AssetTypePageComponent implements OnDestroy {
  public createAssetTypeDisabled = computed(() => this.isDetailsPage() || !this.canCreateAssetType);
  private isDetailsPage = toSignal(this.assetBuilderService.pageState$.pipe(map(page => page === "AssetTypePage")));
  private canCreateAssetType = false;

  constructor(private assetBuilderService: AssetBuilderService, private assetModuleRoleService: RoleService) {
    this.canCreateAssetType = this.assetModuleRoleService.canI('CreateAssetType');
  }
  ngOnDestroy(): void {
    this.assetBuilderService.goToAssetTypesTable();
  }

  addAssetType() {
    this.assetBuilderService.createNewAssetType();
  }
}
